import { __spreadArray } from "tslib";
import { Permission, ResourceType, } from "../../admin-service-typescript-client";
var togglePermission = function (permissions, permission) {
    if (permissions.findIndex(function (permissionToFind) { return permissionToFind === permission; }) >= 0) {
        return permissions.filter(function (permissionFilter) { return permissionFilter !== permission; });
    }
    return permissions.concat([permission]);
};
var togglePermissions = function (permissions, permissionsToToggle) {
    var returnArray = permissionsToToggle.reduce(function (final, permission) {
        if (final.findIndex(function (permissionToFind) { return permissionToFind === permission; }) >= 0) {
            return final.filter(function (permissionFilter) { return permissionFilter !== permission; });
        }
        return final.concat([permission]);
    }, __spreadArray([], permissions, true));
    return returnArray;
};
export var permissionsArray = [
    {
        topic: "campaigns",
        topicDisplay: "Kampagnen",
        accessGrantType: ResourceType.Campaign,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateCampaign;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadCampaign;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateCampaign;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteCampaign;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateCampaign;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadCampaign;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateCampaign;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteCampaign;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateCampaign,
                        Permission.ReadCampaign,
                        Permission.UpdateCampaign,
                        Permission.DeleteCampaign,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateCampaign);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteCampaign);
                if (!readIndex)
                    returnArray.push(Permission.ReadCampaign);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateCampaign);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateCampaign,
                Permission.ReadCampaign,
                Permission.UpdateCampaign,
                Permission.DeleteCampaign,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateCampaign; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateCampaign);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteCampaign; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteCampaign);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadCampaign; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadCampaign);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateCampaign; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateCampaign);
        }
    },
    {
        topic: "contents",
        topicDisplay: "Inhalte",
        accessGrantType: ResourceType.Content,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateContent;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadContent;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateContent;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteContent;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateContent;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadContent;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateContent;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteContent;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateContent,
                        Permission.ReadContent,
                        Permission.UpdateContent,
                        Permission.DeleteContent,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateContent);
                if (!readIndex)
                    returnArray.push(Permission.ReadContent);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateContent);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteContent);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateContent,
                Permission.ReadContent,
                Permission.UpdateContent,
                Permission.DeleteContent,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateContent; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateContent);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteContent; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteContent);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadContent; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadContent);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateContent; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateContent);
        }
    },
    {
        topic: "locations",
        topicDisplay: "Standorte",
        accessGrantType: ResourceType.Location,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateLocation;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadLocation;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateLocation;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteLocation;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateLocation;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadLocation;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateLocation;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteLocation;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateLocation,
                        Permission.ReadLocation,
                        Permission.UpdateLocation,
                        Permission.DeleteLocation,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateLocation);
                if (!readIndex)
                    returnArray.push(Permission.ReadLocation);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateLocation);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteLocation);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateLocation,
                Permission.ReadLocation,
                Permission.UpdateLocation,
                Permission.DeleteLocation,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateLocation; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateLocation);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteLocation; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteLocation);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadLocation; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadLocation);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateLocation; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateLocation);
        }
    },
    {
        topic: "networks",
        topicDisplay: "Netzwerke",
        accessGrantType: ResourceType.Network,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateNetwork;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadNetwork;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateNetwork;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteNetwork;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateNetwork;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadNetwork;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateNetwork;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteNetwork;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateNetwork,
                        Permission.ReadNetwork,
                        Permission.UpdateNetwork,
                        Permission.DeleteNetwork,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateNetwork);
                if (!readIndex)
                    returnArray.push(Permission.ReadNetwork);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateNetwork);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteNetwork);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateNetwork,
                Permission.ReadNetwork,
                Permission.UpdateNetwork,
                Permission.DeleteNetwork,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateNetwork; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateNetwork);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteNetwork; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteNetwork);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadNetwork; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadNetwork);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateNetwork; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateNetwork);
        }
    },
    {
        topic: "players",
        topicDisplay: "Player",
        accessGrantType: ResourceType.Player,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreatePlayer;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadPlayer;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdatePlayer;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeletePlayer;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreatePlayer;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadPlayer;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdatePlayer;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeletePlayer;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreatePlayer,
                        Permission.ReadPlayer,
                        Permission.UpdatePlayer,
                        Permission.DeletePlayer,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreatePlayer);
                if (!readIndex)
                    returnArray.push(Permission.ReadPlayer);
                if (!updateIndex)
                    returnArray.push(Permission.UpdatePlayer);
                if (!deleteIndex)
                    returnArray.push(Permission.DeletePlayer);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreatePlayer,
                Permission.ReadPlayer,
                Permission.UpdatePlayer,
                Permission.DeletePlayer,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreatePlayer; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreatePlayer);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeletePlayer; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeletePlayer);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadPlayer; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadPlayer);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdatePlayer; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdatePlayer);
        }
    },
    {
        topic: "tags",
        topicDisplay: "Tags",
        accessGrantType: ResourceType.Tag,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateTag;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadTag;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateTag;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteTag;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateTag;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadTag;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateTag;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteTag;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateTag,
                        Permission.ReadTag,
                        Permission.UpdateTag,
                        Permission.DeleteTag,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateTag);
                if (!readIndex)
                    returnArray.push(Permission.ReadTag);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateTag);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteTag);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateTag,
                Permission.ReadTag,
                Permission.UpdateTag,
                Permission.DeleteTag,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateTag; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateTag);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteTag; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteTag);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadTag; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadTag);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateTag; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateTag);
        }
    },
    {
        topic: "users",
        topicDisplay: "User",
        accessGrantType: ResourceType.User,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateUser;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadUser;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateUser;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteUser;
            }) >= 0;
            return createIndex && readIndex && updateIndex && deleteIndex;
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateUser;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadUser;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateUser;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteUser;
            }) >= 0;
            if (createIndex || readIndex || updateIndex || deleteIndex) {
                if (createIndex && readIndex && updateIndex && deleteIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateUser,
                        Permission.ReadUser,
                        Permission.UpdateUser,
                        Permission.DeleteUser,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateUser);
                if (!readIndex)
                    returnArray.push(Permission.ReadUser);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateUser);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteUser);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateUser,
                Permission.ReadUser,
                Permission.UpdateUser,
                Permission.DeleteUser,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateUser; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateUser);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteUser; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteUser);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadUser; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadUser);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateUser; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateUser);
        }
    },
    {
        topic: "organisations",
        topicDisplay: "Organisationen",
        accessGrantType: ResourceType.Organisation,
        all: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateOrganisation;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadOrganisation;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateOrganisation;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteOrganisation;
            }) >= 0;
            var adminIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.AdministerOrganisation;
            }) >= 0;
            var switchIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.SwitchToOrganisation;
            }) >= 0;
            return (createIndex &&
                readIndex &&
                updateIndex &&
                deleteIndex &&
                adminIndex &&
                switchIndex);
        },
        toggleAll: function (permissions) {
            var createIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.CreateOrganisation;
            }) >= 0;
            var readIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.ReadOrganisation;
            }) >= 0;
            var updateIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.UpdateOrganisation;
            }) >= 0;
            var deleteIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.DeleteOrganisation;
            }) >= 0;
            var adminIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.AdministerOrganisation;
            }) >= 0;
            var switchIndex = permissions.findIndex(function (permissionToFind) {
                return permissionToFind === Permission.SwitchToOrganisation;
            }) >= 0;
            if (createIndex ||
                readIndex ||
                updateIndex ||
                deleteIndex ||
                adminIndex ||
                switchIndex) {
                if (createIndex &&
                    readIndex &&
                    updateIndex &&
                    deleteIndex &&
                    adminIndex &&
                    switchIndex) {
                    return togglePermissions(permissions, [
                        Permission.CreateOrganisation,
                        Permission.ReadOrganisation,
                        Permission.UpdateOrganisation,
                        Permission.DeleteOrganisation,
                        Permission.AdministerOrganisation,
                        Permission.SwitchToOrganisation,
                    ]);
                }
                var returnArray = [];
                if (!createIndex)
                    returnArray.push(Permission.CreateOrganisation);
                if (!readIndex)
                    returnArray.push(Permission.ReadOrganisation);
                if (!updateIndex)
                    returnArray.push(Permission.UpdateOrganisation);
                if (!deleteIndex)
                    returnArray.push(Permission.DeleteOrganisation);
                if (!adminIndex)
                    returnArray.push(Permission.AdministerOrganisation);
                if (!switchIndex)
                    returnArray.push(Permission.SwitchToOrganisation);
                return togglePermissions(permissions, returnArray);
            }
            return togglePermissions(permissions, [
                Permission.CreateOrganisation,
                Permission.ReadOrganisation,
                Permission.UpdateOrganisation,
                Permission.DeleteOrganisation,
                Permission.AdministerOrganisation,
                Permission.SwitchToOrganisation,
            ]);
        },
        create: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.CreateOrganisation; }) >= 0;
        },
        toggleCreate: function (permissions) {
            return togglePermission(permissions, Permission.CreateOrganisation);
        },
        "delete": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.DeleteOrganisation; }) >= 0;
        },
        toggleDelete: function (permissions) {
            return togglePermission(permissions, Permission.DeleteOrganisation);
        },
        read: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.ReadOrganisation; }) >= 0;
        },
        toggleRead: function (permissions) {
            return togglePermission(permissions, Permission.ReadOrganisation);
        },
        update: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.UpdateOrganisation; }) >= 0;
        },
        toggleUpdate: function (permissions) {
            return togglePermission(permissions, Permission.UpdateOrganisation);
        },
        "switch": function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.SwitchToOrganisation; }) >= 0;
        },
        toggleSwitch: function (permissions) {
            return togglePermission(permissions, Permission.SwitchToOrganisation);
        },
        administer: function (permissions) {
            return permissions.findIndex(function (permission) { return permission === Permission.AdministerOrganisation; }) >= 0;
        },
        toggleAdminister: function (permissions) {
            return togglePermission(permissions, Permission.AdministerOrganisation);
        }
    },
];
// export const mapRolesToPermission = (
//     rolesPermissionObject: UserRolesMappingResponse,
//     roles: Role[]
// ): Permission[] =>
//     [].concat.apply(
//         [],
//         roles.map((role) =>
//             rolesPermissionObject.rolesToPermissions[role]
//                 ? rolesPermissionObject.rolesToPermissions[role]
//                 : []
//         )
//     );
